import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=4eee994e&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=4eee994e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee994e",
  null
  
)

export default component.exports